<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('emailTemplates.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('emailTemplates.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('emailTemplates.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.type') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('type')">
                <el-select
                  data-vv-as="'type'"
                  name="type"
                  class="select-primary"
                  :placeholder="$t('emailTemplates.form.typePlaceholder')"
                  v-model="formDetails.type"
                  v-validate="modelValidations.required">
                  <el-option
                    v-for="option in types"
                    class="select-primary"
                    :value="option"
                    :key="option">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.language') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('language')">
                <el-select
                  data-vv-as="'language'"
                  name="language"
                  class="select-primary"
                  :placeholder="$t('emailTemplates.form.languagePlaceholder')"
                  v-model="formDetails.language"
                  v-validate="modelValidations.required">
                  <el-option
                    v-for="option in languages"
                    class="select-primary"
                    :value="option"
                    :key="option">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.short_name') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'short_name'"
                name="short_name"
                v-validate="modelValidations.required"
                :error="getError('short_name')"
                v-model="formDetails.short_name">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.email_subject') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'email_subject'"
                name="email_subject"
                v-validate="modelValidations.required"
                :error="getError('email_subject')"
                v-model="formDetails.email_subject">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.description') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'description'"
                name="description"
                v-validate="modelValidations.required"
                :error="getError('description')"
                v-model="formDetails.description">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.email_content_html') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('email_content_html')">
                <textarea class="form-control"
                          name="email_content_html"
                          data-vv-as="'email_content_html'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.email_content_html"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('emailTemplates.form.email_content') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('email_content')">
                <textarea class="form-control"
                          name="email_content"
                          data-vv-as="'email_content'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.email_content"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('emailTemplates.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'create-email-template-btn',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    props: {
      types: {
        type: Array,
        required: true,
      },
      languages: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        modal: false,
        alert: false,
        loading: false,
        formDetails: {
          description: '',
          email_content: '',
          email_content_html: '',
          email_subject: '',
          language: '',
          short_name: '',
          type: '',
        },
        modelValidations: {
          required: {
            required: true
          },
        }
      }
    },

    computed: {
      ...mapState({
        updating: state => state.email_templates.updating,
        error: state => state.email_templates.error,
      }),
      getActionErrorDetails() {
        return this.error ? this.error.bodyText : null;
      }
    },
    methods: {
      ...mapActions(['CreateEmailTemplate', 'LoadEmailTemplates']),
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate: function () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.create()
          }
        });
      },
      create: function () {
        let payload = {
          description: this.formDetails.description,
          email_content: this.formDetails.email_content,
          email_content_html: this.formDetails.email_content_html,
          email_subject: this.formDetails.email_subject,
          language: this.formDetails.language,
          short_name: this.formDetails.short_name,
          type: this.formDetails.type,
        }

        this.CreateEmailTemplate(payload).then(() => {
          if (this.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.LoadEmailTemplates();
            this.resetForm();
            this.$notify({
              type: 'success',
              message: this.$t('emailTemplates.create.createdNotification', payload),
              icon: 'tim-icons icon-alert-circle-exc'
            })
          }
        });
      },
      resetForm: function () {
        // closing dialog
        this.modal = false;

        // resetting alerts
        this.alert = false;

        // resetting form
        this.formDetails = {
          description: '',
          email_content: '',
          email_content_html: '',
          email_subject: '',
          language: '',
          short_name: '',
          type: '',
        };

        // reset validation errors
        this.$validator.reset()
      }
    }
  }
</script>
